import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import {
  List,
  TDTypeConsts,
} from "Module/Subscription/business-configration/commons";
import DynamicForm from "Component/DynamicForm";
import { ErrorMessages } from "Constants";
import DrawerHeader from "Component/Headers/drawerHeader";
import Drawer from "@material-ui/core/Drawer";
import SearchSq from "Component/Material-ui/SearchSq";
import ProfilePictureSmall from "Component/Thumbnail/ProfilePictureSmall";
import DefaultProfileImage from "Assets/Images/profile_defaultImg.svg";
import Collapse from "@material-ui/core/Collapse";
import { instance } from "Actions/AxiosInstance";
import get from "lodash/get";

const styles = () => ({
  drawerPaper: {
    width: 356,
  },
});

class Drafts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      headers: [
        {
          key: "payrollgroup",
          name: "Groups",
          type: TDTypeConsts.ASSIGNED_GROUPS,
        },
        {
          key: "modifieddate",
          name: "Last modified",
          style: { width: "20%" },
          type: TDTypeConsts.CREATED_DATE,
        },
        {
          key: "edit",
          name: "",
          type: TDTypeConsts.EDIT_WITHOUT_HEADER,
        },
        {
          key: "delete",
          name: "",
          type: TDTypeConsts.DELETE_WITHOUT_HEADER,
        },
      ],
      alldrafts: [],
      OpenDrawer: false,
      showEmpList: false,
      employeelist: [],
      searchValue: "",
      list: [],
    };

    this.OpenDrawer = this.OpenDrawer.bind(this);
    this.CloseDrawer = this.CloseDrawer.bind(this);
    this.showEmployeeList = this.showEmployeeList.bind(this);
    this.backAction = this.backAction.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.getalldrafts = this.getalldrafts.bind(this);
    this.onRowClicked = this.onRowClicked.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    if (this.props.alldrafts.length == 0) {
      this.getalldrafts();
    } else {
      this.setState({
        alldrafts: this.props.alldrafts,
      });
    }
  }

  componentWillReceiveProps(props) {
    if (props.salarycycle && this.props.salarycycle && props.salarycycle.displayvalue != this.props.salarycycle.displayvalue) {
      this.getalldrafts();
    }
  }

  getalldrafts() {
    const { payrollcycledurationid, salarycycle } = this.props;
    const data = {
      payrollcycledurationid,
      salarycycleid: salarycycle.salarycycleid,
      salarycyclesplitid: salarycycle.displayvalue,
    };
    instance.post("payroll/draftpayroll", data).then((resp) => {
      this.setState({ alldrafts: get(resp, "data.result[0].savedraft", []).filter((x) => x.generateddataid) });
    }).catch((error) => {
      this.props.enqueueSnackbar(
        error.response ? error.response.data.error.message : error.message,
        { variant: "error" },
      );
    });
  }

  OpenDrawer() {
    this.setState({
      OpenDrawer: true,
    });
  }

  CloseDrawer() {
    this.setState({
      OpenDrawer: false,
    });
  }

  handleEmplistExpandClick01 = () => {
    this.setState((state) => ({ expandDebit: !state.expandDebit }));
  };

  showEmployeeList() {
    this.setState({
      showEmpList: true,
    });
  }

  backAction() {
    this.setState({
      showEmpList: false,
    });
  }

  onRowClicked(row) {
    console.log("Response is=>", row);
    const postdataforemplist = {
      payrollcycledurationid: this.props.salarycycle.payrollcycledurationid,
      salarycycleid: this.props.salarycycle.salarycycleid,
      salarycyclesplitid: this.props.salarycycle.displayvalue,
      grouptypeid: this.props.isSpeicalCase ? this.props.selectedOptions[0] && this.props.selectedOptions[0].displayvalue : null,
      payrollgroup: row.payrollgroup,
      payrollmonthid: this.props.salarycycle && this.props.salarycycle.payrollmonthid,
      payrollyear: this.props.salarycycle && this.props.salarycycle.payrollyear,
    };
    instance.post("payroll/employeelist", postdataforemplist).then((resp) => {
      this.setState({
        employeelist: resp.data.result[0].employeelist,
        list: resp.data.result[0].employeelist,
        OpenDrawer: true,
      });
    }).catch((error) => {
      this.props.enqueueSnackbar(
        error.response ? error.response.data.error.message : error.message,
        { variant: "error" },
      );
    });
  }

  handleSearch(e) {
    const { list, employeelist } = this.state;
    const filterList = employeelist.filter(
      (item) =>
        item.empfullname.toLowerCase().search(e.target.value.toLowerCase()) !== -1,
    );
    this.setState({
      searchValue: e.target.value,
      list: e.target.value ? filterList : employeelist,
    });
  }

  onEdit = (row) => {
    const { payrollcycledurationid, salarycycle, filterOptions, empList } = this.props;
    console.log('row: ', row);
    const emptype = row.payrollgroup.find((x) => x.grouptypeid == 4);
    const loc = row.payrollgroup.find((x) => x.grouptypeid == 5);
    const dep = row.payrollgroup.find((x) => x.grouptypeid == 3);
    const bus = row.payrollgroup.find((x) => x.grouptypeid == 2);
    const emps = row.payrollgroup.find((x) => x.grouptypeid == 0);
    const selectedEmpType = emptype && emptype.groupids ? [...emptype.groupids.split(",").map((x) => {
      const albus = filterOptions && filterOptions.find((x) => x.label == "Employement Types");
      if (albus) {
        const obj = albus.options.find((x) => x.displayvalue);
        return ({
          ...obj,
          grouptypeid: 2,
        });
      }
    })] : [];
    let selectedOptions = [...row.payrollgroup.filter((x) => x.grouptypeid == 0
      || x.grouptypeid == 1
      || x.grouptypeid == 60
      || x.grouptypeid == 61
      || x.grouptypeid == 62
      || x.grouptypeid == 100
      || x.grouptypeid == 51).map((x) => ({
        ...x,
        displayvalue: x.grouptypeid,
        displayname: x.grouptypeid == 53
        ? "Deleted payslip employees (From past month)"
        : x.grouptypeid == 52
        ? "New employee (DOJ is of past month)"
        : x.grouptypeid == 51
          ? "Postponed/Hold employees"
          : x.grouptypeid == 100
            ? "FNF employees"
            : x.grouptypeid == 61
              ? "Cheque"
              : x.grouptypeid == 1
                ? "All employees"
                : x.grouptypeid == 0
                  ? "Specific employees"
                  : x.grouptypeid == 60
                    ? "Cash"
                    : "Bank Transfer",
      })),
    ];
    const selectedEmployees = emps && emps.groupids ? [...emps.groupids.split(",").map((x) => {
      const obj = empList.find((y) => y.displayvalue == x);
      return ({
        ...obj,
        grouptypeid: 0,
      });
    })] : [];
    const selectedBus = bus && bus.groupids ? [...bus.groupids.split(",").map((x) => {
      const albus = filterOptions && filterOptions.find((x) => x.label == "Business Units");
      if (albus) {
        const obj = albus.options.find((x) => x.businessunitid);
        return ({
          ...obj,
          grouptypeid: 2,
        });
      }
    })] : [];
    const selectedDep = dep && dep.groupids ? [...dep.groupids.split(",").map((x) => {
      const albus = filterOptions && filterOptions.find((x) => x.label == "Departments");
      if (albus) {
        const obj = albus.options.find((x) => x.departmentid);
        return ({
          ...obj,
          grouptypeid: 2,
        });
      }
    })] : [];
    const selectedLoc = loc && loc.groupids ? [...loc.groupids.split(",").map((x) => {
      const albus = filterOptions && filterOptions.find((x1) => x1.label == "Locations");
      if (albus) {
        const obj = albus.options.find((x2) => x2.displayvalue);
        return ({
          ...obj,
          grouptypeid: 2,
        });
      }
    })] : [];
    selectedOptions = [...selectedOptions,
    ...selectedLoc,
    ...selectedDep,
    ...selectedBus,
    ...selectedEmpType,
    ];
    this.props.updateSelection({
      selectedOptions,
      selectedEmployees,
      selectedBus,
      selectedDep,
      selectedEmpType,
      selectedLoc,
    });

    this.props.setCurrentView(row.stepnumber == 3 ? "salaryadjustment" : row.stepnumber == 4 ? "payrolloverview" : "home");
    const data = {
      payrollcycledurationid,
      salarycycleid: salarycycle.salarycycleid,
      salarycyclesplitid: salarycycle.displayvalue,
      grouptypeid: this.props.isSpeicalCase ? this.props.selectedOptions[0] && this.props.selectedOptions[0].displayvalue : null,
      payrollgroup: row.payrollgroup,
      payrollmonthid: this.props.salarycycle && this.props.salarycycle.payrollmonthid,
      payrollyear: this.props.salarycycle && this.props.salarycycle.payrollyear,
    };
    this.props.setpostdataforemplist(data, true);
  }

  onDelete(row) {
    const {
      salarycycle: { displayvalue, salarycycleid, payrollcycledurationid },
    } = this.props;
    console.log('row: ', row);
    instance.delete("payroll/draftpayroll", {
      data: {
        "payrollcycledurationid": payrollcycledurationid,
        "salarycycleid": salarycycleid,
        "salarycyclesplitid": displayvalue,
        generateddataid: row.generateddataid,
      },
    }).then(() => {
      this.props.enqueueSnackbar(ErrorMessages.E0120, { variant: "success" });
      this.props.setCurrentView("home");
    }).catch((error) => {
      // this.props.setCurrentView("payrolloverview");
      this.props.enqueueSnackbar(
        error.response ? error.response.data.error.message : error.message,
        { variant: "error" },
      );
    });
    // this.props.enqueueSnackbar(`Are you sure want to delete draft?`, {
    //   variant: "warning",
    //   action: [
    //     <Button
    //       key="key"
    //       color="inherit"
    //       size="small"
    //       onClick={this.confirmdelete}
    //     >
    //       Yes
    //     </Button>,
    //     <Button key="key" color="inherit" size="small" onClick={() => this.props.closeSnackbar()}>
    //       No
    //     </Button>,
    //   ],
    // });
  }

  confirmdelete = () => {
    const {
      salarycycle: { displayvalue, salarycycleid, payrollcycledurationid },
    } = this.props;
    this.props.closeSnackbar();
    console.log("here dlelel");

    console.log('displayvalue: ', displayvalue);
    console.log('salarycycleid: ', salarycycleid);
    instance.post("payroll/draftpayroll", {
      data: {
        "payrollcycledurationid": payrollcycledurationid,
        "salarycycleid": salarycycleid,
        "salarycyclesplitid": displayvalue,
      },
    }).then(() => {
      this.props.enqueueSnackbar(ErrorMessages.E0120, { variant: "success" });
      this.props.setCurrentView("home");
    }).catch((error) => {
      // this.props.setCurrentView("payrolloverview");
      this.props.enqueueSnackbar(
        error.response ? error.response.data.error.message : error.message,
        { variant: "error" },
      );
    });
  };

  render() {
    const { showEmpList, alldrafts } = this.state;
    return (
      <div className="margin-top-16">
        <p className="normal-dark-secondary margin-bottom-16">
          Pick up where you left off, you can find your saved drafts below. 💾
        </p>
        <List
          onCreate={this.onCreate}
          onGroupClicked={this.onRowClicked}
          list={alldrafts}
          headers={this.state.headers}
          permissions={this.state.permissions}
          onEdit={this.onEdit}
          onDelete={this.onDelete}
          module="payroll draft"
        />
        {/* <p onClick={this.OpenDrawer}>btn</p> */}
        <Drawer
          anchor="right"
          open={this.state.OpenDrawer}
          onClose={this.CloseDrawer}
          style={{ padding: 40 }}
          classes={{
            paper: "planner-drawer padding15 width25",
          }}
        >
          <div>
            <DrawerHeader
              header={showEmpList ? "Applicable employees" : "Group list"}
              isbackarrow={showEmpList}
              closeDrawer={showEmpList ? this.backAction : this.CloseDrawer}
            />
            <SearchSq
              placeholder="Search groups..."
               value={this.state.searchValue}
               onChange={this.handleSearch}
              // className="margin-bottom-8"
            />

            <div className="margin-top-16 margin-bottom-32">
              {/* selected employee list map div */}
              { this.state.list.map((emp) => (
                  (
                    <div key={emp.employeeid} style={{ marginBottom: "30" }}>
                      <div className="payroll-employee-list">
                        <div
                          className="floatleft margin-right-8"
                          style={{ paddingTop: 3 }}
                        >
                          <div>
                            <ProfilePictureSmall src={DefaultProfileImage} />
                          </div>
                        </div>
                        <div className="floatleft">
                          <p className="small-blue t-bold">{emp.empfullname}</p>
                          <p className="small-dark-secondary">{emp.designation}</p>
                        </div>
                        <div className="clear-float"></div>
                      </div>
                    </div>
                  )
                )) }
            </div>
          </div>
        </Drawer>
      </div>
    );
  }
}

export default connect()(
  withStyles(styles, { withTheme: true })(withSnackbar(Drafts)),
);
